import { useState } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { LaunchList } from "@/components/LaunchList";
import { Pricing } from "@/components/Pricing";
import { Faq } from "@/components/Faq";
import { ServiceArea } from "@/components/ServiceArea";
import { BookingForm } from "@/components/BookingForm";
import { Footer } from "@/components/Footer";

export default function Home() {
    const [selected, setSelected] = useState("");

    return (
        <main className="overflow-x-clip bg-monster-cream font-body text-monster-navy">
            <Navbar />
            <Hero />
            <Marquee />
            <LaunchList />
            <Pricing />
            <Faq />
            <ServiceArea />
            <BookingForm selected={selected} onSelect={setSelected} />
            <Footer />
        </main>
    );
}
